import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';

const contextTypes = {
  router: PropTypes.object,
};

class FavoriteModal extends React.Component {

  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.routeAndClose = this.routeAndClose.bind(this);
  }

  componentDidMount() {
    modalViewGA('favorite-confirm');
  }

  closeModal(e){
    this.props.removeModal();
  }

  routeAndClose (e, username){
    e.preventDefault();
    this.props.removeModal();
    this.context.router.push('/livecams/members/'+ username);
  }

  render(){
    const {username, feedTitle} = this.props;
    return (
      <div>
        <div className="modals-popup favorite-modal">
          <div className="modal-header d-flex align-items-center">
            <div className="col">LIVECAM FAVORITES</div>
          </div>

          <div className="info d-flex">
            <div className="p-20 mx-auto text-center u-font-foundation-roman u-textSize-20">
              <div className="favorite-modal-info">
                This LiveCam <br/>
                <span className="u-font-foundation-bold">{feedTitle}</span> <br/>
                Has Been Added <br/>
                to Your Favorites
              </div>
              <div>
                <Link to={`/livecams/members/${username}`} onClick={this.closeModal}>
                  <button className="mt-10 btn btn-secondary whole-width">
                    view your favorites
                  </button>
                </Link>
              </div>
              <div>
                <button className="btn btn-primary whole-width mt-10" onClick={this.closeModal}>Done</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FavoriteModal.contextTypes = contextTypes;

export default FavoriteModal;
